import { makeStyles } from 'tss-react/mui';

export const useSearchStyles = makeStyles<boolean>({ name: 'Search' })(
  (theme, hasSearchContent) => ({
    root: {
      height: 32,
      borderRadius: theme.shape.borderRadiusMd,
      paddingLeft: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,

      '& svg': {
        width: 24,
        height: 24,
      },
    },
    searchIcon: {
      color: theme.palette.grey[500],
    },
    iconButton: {
      height: 32,
      width: 32,
      border: 'none',
      visibility: hasSearchContent ? 'visible' : 'hidden',
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      '& > svg': {
        height: 20,
        width: 20,
      },
    },
  }),
);
